module.exports = __webpack_public_path__ + "assets/img/tx102s_1.0519a067.jpg";